import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";

function downloadCSV(rows, filename) {
  const csv = rows.map(r => r.map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export default function Jcardreport() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDepartment, setselectedDepartment] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [customer, setcustomer] = useState([]);
  const [custId, setCustId] = useState();
  useEffect(() => {
    http.get(`/get_customer`).then((res) => {
      setcustomer(res.data.users);
    });
    fetchTaskDetails(startDate, endDate, custId);
  }, [startDate, endDate, custId]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleDepartmentChange = (event) => {
    setselectedDepartment(event.target.value);
  };

  const fetchTaskDetails = (startDate = "", endDate = "", custIds = "") => {
    setIsLoading(true);

    let endpoint = `/reportjcard?startdate=${startDate}&enddate=${endDate}&custid=${custIds}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };
  const options = customer.map((user) => ({
    value: user.id,
    label: `${user.name} - ${user.phone} - ${user.company}`,
  }));
  console.log(custId);
  console.log(tasks);
  return (
    <>
      <Toaster />
      <div className="container mt-1">
        <div className="row mb-4 mt-4">
          <div className="col-md-2 form-group text-end mt-3">
            <input
              name="start_date"
              onChange={handleChangeStartDate}
              class="form-control"
              type="date"
            ></input>
          </div>

          <div className="col-md-2 form-group text-end mt-3">
            <input
              name="end_date"
              onChange={handleChangeEndDate}
              class="form-control"
              type="date"
            ></input>
          </div>

          <div className="col-md-4 form-group mt-3">
            <Select
              options={options}
              name="customer_id"
              value={options.find((option) => option.value === custId)}
              onChange={(selectedOption) => setCustId(selectedOption.value)}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-2">
          <h1 className="mb-0">JC Reports</h1>
          <button
            className="btn btn-sm btn-outline-success"
            disabled={tasks.length === 0}
            onClick={() => downloadCSV(
              [["No", "Name", "Company/Walk-In", "Phone", "Total Visits"],
               ...tasks.map((r, i) => [i + 1, r.customer_name, r.company, r.phone, r.count])],
              `jc_report_${moment().format("YYYYMMDD_HHmm")}.csv`
            )}
          >⬇ CSV</button>
        </div>
        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>Company/Walk-In</th>
                  <th>Phone</th>
                  <td>Total Visits</td>
                </tr>
              </thead>
              <tbody>
                {tasks.map((user_rep, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td className="text-uppercase">{user_rep.customer_name}</td>
                    <td className="text-uppercase">{user_rep.company}</td>
                    <td className="text-uppercase">{user_rep.phone}</td>
                    <td className="text-danger">
                      <b>{user_rep.count}</b>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
